// One JSON file per customer, holding that customer's whole configurator:
// branding, presentation, models, scene and catalog. This is the same shape the
// widget accepts through `data-config`, so a config produced by the future
// admin panel can be dropped in here (or served) without any conversion.
//
// The files are plain JSON on purpose: they must stay editable by non-developers
// and by tooling, so they cannot reference constants — every value is a literal.
import { STARTUP_CONFIG_IDS } from "@/shared/config/constants";
import type { ConfiguratorConfig } from "@/configurator/domain/models/types";
import situsJson from "@/configurator/data/api/configs/situs.json";
import mainJson from "@/configurator/data/api/configs/main.json";
import antaresJson from "@/configurator/data/api/configs/antares.json";

export const situsConfig = situsJson as ConfiguratorConfig;
export const mainConfig = mainJson as ConfiguratorConfig;
export const antaresConfig = antaresJson as ConfiguratorConfig;

export const builtinConfigs: Record<string, ConfiguratorConfig> = {
  [situsConfig.id]: situsConfig,
  [mainConfig.id]: mainConfig,
  [antaresConfig.id]: antaresConfig,
};

export function getConfigById(
  id: string | undefined,
): ConfiguratorConfig | undefined {
  if (!id) return undefined;
  return builtinConfigs[id];
}

export function getStartupConfig(
  surface: keyof typeof STARTUP_CONFIG_IDS,
): ConfiguratorConfig {
  return builtinConfigs[STARTUP_CONFIG_IDS[surface]];
}
